import { Outlet } from 'react-router-dom';
import { FC } from 'react';

export const LoadPage: FC = () => {
  return <Outlet />;
};
